/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Switch_LanguageInputs */

const en_common_switch_language = /** @type {(inputs: Common_Switch_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`language`)
};

const es_common_switch_language = /** @type {(inputs: Common_Switch_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`idioma`)
};

/**
* | output |
* | --- |
* | "language" |
*
* @param {Common_Switch_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_switch_language = /** @type {((inputs?: Common_Switch_LanguageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Switch_LanguageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_switch_language(inputs)
	return es_common_switch_language(inputs)
});